import TiptapEditor from '../../components/TipTapEditor/TipTapEditor'
import PortfolioRegionSettings from './PortfolioRegionSettings'
import clsx from 'clsx'
import { cloneDeep, set } from 'lodash'
import IconMenu from '../../components/IconMenu/IconMenu'
import { ReactComponent as GearIcon } from 'assets/icons/gear.svg'
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg'
import Modal from 'react-modal'
import { useState } from 'react'
import { usePutUserPreferenceMutation } from '../../api/api'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
const PortfolioContentEditor = ({ values, onChange, region, isPreview }) => {
  const [putUserPreference, { isLoading, error, reset }] =
    usePutUserPreferenceMutation()
  const [defaultModalOpen, setDefaultModalOpen] = useState(false)
  const theme = values?.pageData?.theme || 'dark'
  const editorData = values?.pageData?.[region]
  const iconColor = theme === 'dark' ? '#ccc' : '#676767'

  function openSetDefaultModal() {
    reset()
    setDefaultModalOpen(true)
  }

  function handleEditorChange(content) {
    const newValues = cloneDeep(values)
    set(newValues, ['pageData', region, 'content'], content)
    onChange(newValues)
  }

  function handleSetAsDefault() {
    putUserPreference({
      defaultPortfolioContent: editorData.content,
    }).then(({ error }) => {
      if (!error) {
        setDefaultModalOpen(false)
      }
    })
  }

  return (
    <div className="w-full h-full flex flex-col">
      {!isPreview && (
        <>
          <div
            className={clsx('flex rounded-t py-2 px-6 items-center', {
              'bg-deep': theme === 'dark',
              'bg-white': theme === 'light',
            })}
          >
            <h5 className="mt-[-2px]">About Me</h5>
            <PortfolioRegionSettings
              values={values}
              onChange={onChange}
              region={region}
            />
            <IconMenu
              icon={<GearIcon fill={iconColor} height="24" />}
              tooltip="Settings"
            >
              <button onClick={openSetDefaultModal} className="">
                <SaveIcon fill="#ccc" height="18" />
                Save as Default
              </button>
            </IconMenu>
          </div>
        </>
      )}
      <div
        className={clsx('p-4 flex flex-fill rounded-b', {
          'bg-gray-light': theme === 'dark' && !isPreview,
          'bg-white': theme === 'light' && !isPreview,
        })}
      >
        <TiptapEditor
          values={editorData}
          onChange={handleEditorChange}
          theme={theme}
          isPreview={isPreview}
        />
      </div>
      <Modal
        isOpen={defaultModalOpen}
        onRequestClose={() => setDefaultModalOpen(false)}
        contentLabel="Save Content as Default"
        className="modal w-[600px]"
        overlayClassName="modal-overlay"
      >
        <div className="p-6 relative">
          <h2 className={clsx({ 'mb-8': !error, 'mb-4': error })}>
            Save Content as Portfolio Default
          </h2>
          {error && (
            <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
              <p>
                An unknown error has occurred, your default content could not be
                updated. Please try again or contact support for more help.
              </p>
            </div>
          )}
          <p className="mt-4">
            Would you like to save the current content as the default for new
            portfolios? This will overwrite an existing default you current
            have.
          </p>
          <div className="flex justify-end mt-12">
            <button
              className="button "
              onClick={() => setDefaultModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="button bg-pink hover:bg-pink-off"
              onClick={handleSetAsDefault}
            >
              Set As Default
            </button>
          </div>
          {isLoading && <LoadingBlocker />}
        </div>
      </Modal>
    </div>
  )
}

export default PortfolioContentEditor
